import { EditorContent } from "@tiptap/react";
import { RefObject, useMemo } from "react";

import { GenerationGeniusAPIResponse } from "@/types/models/GenerationGenius.interface";
import useGeniusEditor from "@/view/GeniusContent/utils/useGeniusEditor/useGeniusEditor";
import PanelHeader from "@/view/PanelHeader";

import { Assignment } from "@/types/models/Assignment.interface";
import useGetUserProperties from "@/users/v3/useGetUserProperties";
import { formatGeniusActivityPanelContent } from "../GeniusContent/utils";
import { IGeniusButtonEventProperties } from "../GeniusContent/GeniusActivityPanel/GeniusActivityPanel.constant";
import useAssignmentReducerContext from "../utils/useAssignmentReducerContext";
import {
  drawerContainerCss,
  titleCss,
} from "./GeniusDiscussionContainer.style";

interface GeniusDiscussionContainerProps {
  backButtonEventProperties: IGeniusButtonEventProperties;
  closeButtonEventProperties: IGeniusButtonEventProperties;
  onClickBackButton: () => void;
  onClickCloseButton?: () => void;
  contentData: GenerationGeniusAPIResponse;
  shouldFocusCloseButtonRef: RefObject<boolean>;
}

export const GeniusDiscussionContainer = ({
  backButtonEventProperties,
  closeButtonEventProperties,
  onClickCloseButton,
  onClickBackButton,
  contentData,
  shouldFocusCloseButtonRef,
}: GeniusDiscussionContainerProps) => {
  const { updatedAssignment } = useAssignmentReducerContext() as {
    updatedAssignment: Assignment;
  };

  const { isStudent } = useGetUserProperties() || {};

  const { hide_generation_genius_discussion_answers: hideDiscussionAnswers } =
    updatedAssignment.assignment_config || {};

  const shouldHideDiscussionAnswers = Boolean(
    isStudent && hideDiscussionAnswers,
  );

  const { discussionQuestions } = useMemo(
    () =>
      formatGeniusActivityPanelContent(
        contentData,
        shouldHideDiscussionAnswers,
      ),
    [contentData.discussion_questions, shouldHideDiscussionAnswers],
  );
  const editor = useGeniusEditor({ content: discussionQuestions });

  return (
    <>
      <PanelHeader
        onClickBackButton={onClickBackButton}
        onClickCloseButton={onClickCloseButton}
        closeButtonEventProperties={closeButtonEventProperties}
        backButtonEventProperties={backButtonEventProperties}
        shouldFocusCloseButtonRef={shouldFocusCloseButtonRef}
      >
        <h2 css={titleCss}>Discussion Questions</h2>
      </PanelHeader>

      <div css={drawerContainerCss}>
        <EditorContent editor={editor} />
      </div>
    </>
  );
};

export default GeniusDiscussionContainer;
